const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32,34.99A11.57266,11.57266,0,0,0,43.37,24.34l.5-7.66a11.896,11.896,0,1,0-23.74,0l.5,7.66A11.57266,11.57266,0,0,0,32,34.99Z",
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.34,37.11c-.07.02-.14.04-.2.06-.32.1-7.62,2.64-5.39,15.63a2.468,2.468,0,0,0,1.26,1.77A49.85958,49.85958,0,0,0,31.71,60h.56a49.88934,49.88934,0,0,0,21.72-5.43,2.468,2.468,0,0,0,1.26-1.77c2.23-12.99-5.07-15.53-5.39-15.63-.06-.02-.13-.04-.2-.06a27.48235,27.48235,0,0,1-5.41-1.83,2.474,2.474,0,0,0-2.4.15l-3.6532,2.3291a11.52674,11.52674,0,0,1-12.39356,0L22.15,35.43a2.474,2.474,0,0,0-2.4-.15A27.48235,27.48235,0,0,1,14.34,37.11Z",
    id: "id_102",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/username.fed7d740e8125275176b3a669ca82484.svg";
export { ForwardRef as ReactComponent };